/**
 * Delivery Date Calculator
 * Shows a 1-week delivery window (lead days − 3 to lead days + 3)
 * based on vendor lead time.
 */
(function () {
  'use strict';

  const deliveryEl = document.getElementById('estimated-delivery-date');
  if (!deliveryEl) return;

  const leadTimeDays = parseInt(deliveryEl.dataset.leadDays, 10);
  if (isNaN(leadTimeDays) || leadTimeDays < 1) return;

  const opts = { day: 'numeric', month: 'short' };

  // Start of window: lead days - 3
  const startDate = new Date();
  startDate.setDate(startDate.getDate() + leadTimeDays - 3);

  // End of window: lead days + 3
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + leadTimeDays + 3);

  // If both dates are in the same month: "1 - 7 Aug 2026"
  // If they span months: "29 Jul - 4 Aug 2026"
  const startDay = startDate.toLocaleDateString('en-IE', { day: 'numeric' });
  const startMonth = startDate.toLocaleDateString('en-IE', { month: 'short' });
  const endDay = endDate.toLocaleDateString('en-IE', { day: 'numeric' });
  const endMonth = endDate.toLocaleDateString('en-IE', { month: 'short' });
  const year = endDate.getFullYear();

  let formatted;
  if (startDate.getMonth() === endDate.getMonth()) {
    formatted = `${startDay} - ${endDay} ${endMonth} ${year}`;
  } else {
    formatted = `${startDay} ${startMonth} - ${endDay} ${endMonth} ${year}`;
  }

  deliveryEl.textContent = formatted;
})();
